import { setLocalStorageData } from '../../utils/LocalStorage';

function addHours(numOfHours, date = new Date()) {
  date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  //  1 min -> for testing
  // date.setTime(date.getTime() + (1 / 60) * 60 * 60 * 1000);
  return date;
}

// To keep track of inactive time || using localStorage to manage in all tabs
const updateExpiredTime = (timeout) => {
  // const loginTime = new Date().getTime();
  // const expirationTime = loginTime + 8 * 60 * 60 * 1000;
  // setLocalStorageData('logoutTime', expirationTime)
  // setLocalStorageData('loginTime', loginTime)
  setLocalStorageData('_expiredTime', addHours(timeout).toString());
};

// To tackle mouse click, mouse movement, and keyboard click
const tackleMovement = () => {
  window.addEventListener('mousemove', () => updateExpiredTime(8));
  window.addEventListener('scroll', () => updateExpiredTime(8));
  window.addEventListener('keydown', () => updateExpiredTime(8));
};

// If the user is active
const isLogged = () => {
  updateExpiredTime(8);
  tackleMovement();
};

// If the user is inactive
const cleanUp = () => {
  window.removeEventListener('mousemove', () => updateExpiredTime(8));
  window.removeEventListener('scroll', () => updateExpiredTime(8));
  window.removeEventListener('keydown', () => updateExpiredTime(8));
};

export { isLogged, cleanUp };
